import { ProductType } from '../../@types/product';
import { SubscriptionInformation } from '../../@types/subscription-articles';
import { APP_CONFIG } from '../../config';
import { get } from '../request';

export const getSubscriptionInformation = async (
  productType: ProductType = ProductType.WohnenPlus,
  articleConfigurationId: string,
) => {
  return await get<SubscriptionInformation[]>(
    `${APP_CONFIG.baseApiUrl}/warenkorb-api/public/articles?productType=${productType}&articleConfigurationId=${articleConfigurationId}`,
  );
};
